// Records which search result a person opened.
//
// The backend counts distinct people per result over a rolling window and lifts popular
// results in the ranking (ted: `domain/search/clicks.py`). Nothing personal is sent: the
// entity, the query, the row's position, and the GA client id - which the tracking
// pipeline already uses - so different people can be told apart without knowing who they are.
//
// Fire-and-forget, like everything in lib/tracking.ts: never awaited, never throws into a
// click handler, never delays navigation.

import axios from "axios";

import { OmniResult } from "./types";

export type SearchSource = "header" | "header-mobile" | "stock-search-bar";

const CLICK_PATH = "/interface/api/search/click";

/** GA4 client id from the `_ga` cookie (`GA1.1.<a>.<b>` -> `<a>.<b>`), or "". */
function gaClientId(): string {
    try {
        if (typeof document === "undefined") return "";
        const match = document.cookie.match(/(?:^|; )_ga=([^;]*)/);
        if (!match) return "";
        const parts = decodeURIComponent(match[1]).split(".");
        return parts.length >= 4 ? `${parts[2]}.${parts[3]}` : "";
    } catch {
        return "";
    }
}

export function recordSearchClick(result: Pick<OmniResult, "key" | "kind" | "route">, query: string, rank: number, source: SearchSource): void {
    try {
        if (typeof window === "undefined" || !result || !result.key || !result.route) return;
        void axios
            .post(
                CLICK_PATH,
                {
                    entity_key: result.key,
                    kind: result.kind,
                    route: result.route.slice(0, 300),
                    query: (query || "").slice(0, 128),
                    rank: Math.max(0, Math.min(100, rank || 0)),
                    client_id: gaClientId(),
                    source,
                },
                { timeout: 3000 }
            )
            .catch(() => undefined);
    } catch {
        // Recording a click must never break opening the result.
    }
}
